import { createReducer } from "@reduxjs/toolkit";
import { CompanyLine } from "model/CompanyLine";
import { createCompanyLineAction } from "./store";

export interface CompanyLineState {
    list: CompanyLine[],
    loading: boolean
}

const INITIAL_STATE: CompanyLineState = {
    list: [],
    loading: false
};

export const createCompanyLineReducer = (state: CompanyLineState = INITIAL_STATE, action: any) => {
    const companyLineAction = createCompanyLineAction();

    state = createReducer(state, builder => {
        builder
        .addCase(companyLineAction.getCompanyLines.fulfilled, (state, action) => {
            state.loading = false;
            state.list = action.payload;
        })
        .addCase(companyLineAction.getCompanyLines.pending, (state) => {
            state.loading = true;
        })
        .addCase(companyLineAction.getCompanyLines.rejected, (state) => {
            state.loading = false;
        })
    })(state, action);

    return state;
}
